import alertIcon from '@/assets/icons/alert.svg';

import { cn } from '@/shared/lib/cn';

const toneStyle = {
  headerBg: 'bg-warning/10',
  ring: 'bg-warning-strong/5 shadow-halo-warning',
  border: 'border-warning-strong/20',
  iconBg: 'bg-warning',
  iconSrc: alertIcon,
} as const;

export interface HubModalWarningHeaderProps {
  title: string;
  titleId: string;
  /** Merged after default header strip classes (e.g. Figma peach `bg-[#FFF5F0]`). */
  headerClassName?: string;
  /** Merged after default title classes (e.g. bold navy for delete confirmation). */
  titleClassName?: string;
}

/** Warm-orange alert icon + title strip shared by hub confirmation modals (matches Figma treatment). */
export function HubModalWarningHeader({
  title,
  titleId,
  headerClassName,
  titleClassName,
}: HubModalWarningHeaderProps) {
  return (
    <div
      className={cn('flex w-full flex-col items-center gap-2 py-4', toneStyle.headerBg, headerClassName)}
    >
      <div className="relative flex items-center justify-center">
        <div className={`flex size-[100px] items-center justify-center rounded-full ${toneStyle.ring}`}>
          <div className={`flex items-center justify-center rounded-full border-[10px] ${toneStyle.border}`}>
            <div
              className={`flex size-[60px] items-center justify-center overflow-hidden rounded-full ${toneStyle.iconBg}`}
            >
              <img src={toneStyle.iconSrc} alt="" aria-hidden className="size-[60px] shrink-0" />
            </div>
          </div>
        </div>
      </div>
      <h2
        id={titleId}
        className={cn(
          'px-6 text-center text-xl font-semibold leading-normal text-ink',
          titleClassName,
        )}
      >
        {title}
      </h2>
    </div>
  );
}
